import EditMaterialModal from "./EditMaterialModal";

export default EditMaterialModal